module.exports = __webpack_public_path__ + "img/qrbg.049cf701.png";